import React, { useState } from "react";
import {
  SectionCard,
  IconColumn,
  IconPlaceholder,
  ContentColumn,
  SectionHeader,
  SectionTitle,
  SectionSubtitle,
  ChangeHistoryLink,
} from "./styledComponents";
import { AuditEditLabel } from "./AuditEditLabel";

export type AuditSectionProps = {
  icon: string;
  iconAlt: string;
  title: string;
  label: string;
  date: string;
  author: string;
  deleted?: boolean;
  latestContent: React.ReactNode;
  historyItems?: React.ReactNode[];
};

/**
 * Reusable audit section component that displays a card with icon, header,
 * latest content, and optional expandable history.
 */
export const AuditSection = ({
  icon,
  iconAlt,
  title,
  label,
  date,
  author,
  deleted = false,
  latestContent,
  historyItems = [],
}: AuditSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasHistory = historyItems.length > 0;

  return (
    <SectionCard>
      <IconColumn>
        <IconPlaceholder>
          <img src={icon} alt={iconAlt} style={{ width: "24px", height: "24px" }} />
        </IconPlaceholder>
      </IconColumn>

      <ContentColumn>
        <SectionHeader>
          <SectionTitle deleted={deleted}>{title}</SectionTitle>
          <SectionSubtitle deleted={deleted}>
            <AuditEditLabel label={label} date={date} author={author} />
          </SectionSubtitle>
        </SectionHeader>

        {latestContent}

        {hasHistory && (
          <>
            <ChangeHistoryLink onClick={() => setIsExpanded(!isExpanded)}>
              Change history
              <i className={`pi pi-angle-${isExpanded ? "up" : "down"}`} />
            </ChangeHistoryLink>

            {isExpanded && historyItems}
          </>
        )}
      </ContentColumn>
    </SectionCard>
  );
};
